import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
// import './style.css';
import SplashCursor from './components/SplashCursor'

function App() {
  useEffect(() => {
    if (window.AOS) window.AOS.init();
    if (window.PureCounter) new window.PureCounter();
    if (window.Swiper) {
      try {
        new window.Swiper('.testimonials-slider', {
          loop: true,
          speed: 600,
          autoplay: { delay: 4000 },
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 20,
          pagination: { el: '.swiper-pagination', clickable: true },
          breakpoints: {
          768: { slidesPerView: 1.5, spaceBetween: 30 },
          // 992: { slidesPerView: 2, spaceBetween: 30 },
          1200: { slidesPerView: 3, spaceBetween: 40 },
      },
        });
      } catch (e) {}
    }
    const handler = (e) => {
      const a = e.target.closest && e.target.closest('a');
      if (a && a.getAttribute('href') && a.getAttribute('href').startsWith('#')) {
        e.preventDefault();
        const id = a.getAttribute('href').slice(1);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      {/* <Portfolio /> */}
      <WhyUs />
      <Testimonials />
      <Contact />
      <Footer />
      <SplashCursor />
    </div>
  );
}

export default App;
